import React from "react";
//Material Imports
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles"; // Limitless imports

import { useCustomerHistoryContext } from "../../hooks/customer-history/CustomerHistoryContext";
import { useTranslation } from "../../../common/hooks/translation/TranslationContext";
import MessageHistoryListItem from "./MessageHistoryListItem";
var useStyles = makeStyles(function (theme) {
  return {
    alignCenter: {
      paddingTop: "10px",
      textAlign: "center"
    },
    noMessageTxt: {
      padding: "10px 0px 10px 15px"
    },
    mhlContainer: {
      position: "relative",
      overflow: "auto",
      paddingTop: "0px",
      flex: "1 1 auto"
    },
    header: {
      backgroundColor: theme.palette.history ? theme.palette.history.backgroundColor : "#f7f8fa",
      color: theme.palette.history ? theme.palette.history.textColor : null,
      borderBottom: "1px solid #f3f4f5",
      paddingTop: 0,
      paddingBottom: 0
    }
  };
});

var MessageHistoryList = function MessageHistoryList(_ref) {
  var onMessageHistoryClick = _ref.onMessageHistoryClick;

  var _useCustomerHistoryCo = useCustomerHistoryContext(),
      history = _useCustomerHistoryCo.history;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var classes = useStyles();
  var loading = history.loading,
      activeMessages = history.activeMessages,
      previousMessages = history.previousMessages;

  var getItems = function getItems(messages) {
    if (loading) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.alignCenter
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        size: 24
      }));
    }

    if (!messages || messages.length === 0) {
      return /*#__PURE__*/React.createElement(Typography, {
        className: classes.noMessageTxt,
        component: "div"
      }, t("No messages"));
    } else {
      return messages.map(function (item, key) {
        return /*#__PURE__*/React.createElement(MessageHistoryListItem, {
          key: key,
          message: item,
          onClickHandle: onMessageHistoryClick
        });
      });
    }
  };

  return /*#__PURE__*/React.createElement(List, {
    className: classes.mhlContainer,
    component: "div"
  }, /*#__PURE__*/React.createElement(ListSubheader, {
    classes: {
      root: classes.header
    },
    component: "div"
  }, t("Active Conversations")), getItems(activeMessages), /*#__PURE__*/React.createElement(ListSubheader, {
    classes: {
      root: classes.header
    },
    component: "div"
  }, t("Previous Conversations")), getItems(previousMessages));
};

export default MessageHistoryList;